import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import FullStory from './lib/utils/full_story';
import { platform } from './lib/constants/SiteVariables';

const fullStory = new FullStory();
fullStory.init(platform());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);